import { DISPLAY_NAME, useContentContext } from '../../content'
import type { ContentScopedProps } from '../../content.types'
import { ContentSubtitleVariants } from './content-subtitlte.styles'

type ContentSubtitleProps = {
  children: React.ReactNode
}

export function ContentSubtitle(props: ContentSubtitleProps) {
  const { children, __scopeContent } =
    props as ContentScopedProps<ContentSubtitleProps>
  const { size } = useContentContext(DISPLAY_NAME, __scopeContent)

  return (
    <p
      className={ContentSubtitleVariants({ size })}
      data-testid="content-subtitle"
    >
      {children}
    </p>
  )
}
